export const ApartmentAreaTypes = {
  SHOW_APARTMENT_AREA_DEBT: "SHOW_APARTMENT_AREA_DEBT",
  ADD_AREA_DEBT: "ADD_AREA_DEBT",
};
